import { useEffect, useRef } from 'react';

interface OnResizeReturn {
  width: number;
  height: number;
}

interface UseResizeObserver {
  onResize: ({ width, height }: OnResizeReturn) => void;
  onBody?: boolean;
}

export const useResizeObserver = <RefType>({ onResize, onBody = false }: UseResizeObserver) => {
  const ref = useRef<RefType>(null);

  useEffect(() => {
    const observer = new ResizeObserver(([entry]) => {
      onResize({
        width: entry.contentRect.width,
        height: entry.contentRect.height,
      });
    });
    observer.observe(onBody ? document.body : ref.current as Element);

    return () => observer.disconnect();
  }, []);

  return { ref };
};